import { computed } from 'vue'

import { useConfigStore } from '../../stores/config'
import { adPlacementConfigSchema } from '../types/ad-slot-types'
import { useDeviceType } from './use-device-type'
import { usePageType } from './use-page-type'

import type { ComputedRef } from 'vue'
import type { AdPlacement } from '../types/ad-slot-types'

export function useAdPlacement (): ComputedRef<AdPlacement | null> {
  const configStore = useConfigStore()
  const adPlacementConfig = computed(() => {
    const parsedConfig = adPlacementConfigSchema.safeParse(configStore.rsConfig.adPlacement)
    if (!parsedConfig.success) {
      console.error(parsedConfig.error)
      throw new Error('Invalid ad placement configuration')
    }

    return parsedConfig.data
  })

  const deviceType = useDeviceType()
  const pageType = usePageType()

  return computed(() => {
    if (!deviceType.value || !pageType.value) {
      return null
    }

    const placementForPage = adPlacementConfig.value[pageType.value]
    if (!placementForPage) {
      return null
    }

    const placementForDevice = placementForPage[deviceType.value]
    if (!placementForDevice) {
      return null
    }

    return placementForDevice
  })
}
